import { postHistoric } from "../postHistoric";
import formatDate from "../../utils/formatDate";

export async function completions(api, messages, config, send, updateHistoric, setReturnText, setSubmit, chat=false, submit=true) {
    const url = "https://api.openai.com/v1/chat/completions";
    const apiKey = process.env.REACT_APP_OPENAI_KEY;
    const access =  `Bearer ${apiKey}`

    let finalText = '';

    const handleProgressUpdates = (responseText) => {
        const newUpdates = responseText
            .replace("data: [DONE]", "")
            .trim()
            .split('data: ')

        const newUpdatesParsed = newUpdates.filter((e)=> e !== '').map((update) => {
            const parsed = JSON.parse(update);
            return parsed?.choices[0]?.delta?.content || '';
        });

        const newUpdatesJoined = newUpdatesParsed.join('');

        if (finalText === ''){
            finalText = initialText + newUpdatesJoined;
        } else {
            finalText = finalText + newUpdatesJoined;
        }
        
        setReturnText(finalText);
    };

   

    let initialText = '';

    let sendJson = JSON.stringify({
        model: config.model,
        messages: messages,
        temperature: config.temperature,
        max_tokens:config.max_tokens,
        top_p: config.top_p,
        frequency_penalty: config.frequency_penalty,
        presence_penalty: config.presence_penalty,
        stream: true,
        user:`user${config.user}`
    })


    


    async function postData(url, sendJson, access) {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": access
            },
            body: sendJson
        });
    
        if (!response.ok) {
            setSubmit(false);
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
    
        const reader = response.body.getReader();
    
        while (true) {
            const {value, done} = await reader.read();
            if (!submit){
                break
            }
            if (done) {
                if (chat){
                    setReturnText(finalText);
                }
                else {
                    setReturnText(finalText);
                }
                await postHistoric({
                    send: send,
                    text: JSON.stringify(messages),
                    result: finalText,
                    date: formatDate(new Date()),
                    action: api
                })
                updateHistoric.set(finalText);
                setSubmit(false);
                break
            };
            handleProgressUpdates(new TextDecoder("utf-8").decode(value))
        }


    }
    postData(url, sendJson, access)

}



